import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import AddCategoryIndex from "../../../components/SidetabPages/TemplateCategory/AddCategoryIndex";

const AddCategory = () => {
  return (
    <>
      <AnnouncementBar />
      <AddCategoryIndex />
    </>
  );
};
export default AddCategory;
